export default __webpack_public_path__ + "static/awesomecoffee-7392e5fea5fb5ac2bf4b320da5e754af.png";